module.exports = __webpack_public_path__ + "img/right-arrow.9521ba7e.svg";